import React from 'react';
import PropTypes from 'prop-types';
import { Components, translate } from 'versafleet-core';
import GlobalSearchItem from './item';

class GlobalSearchDropdown extends React.Component {
  _renderResults() {
    if (this.props.tasks.length > 0 || this.props.jobs.length > 0) {
      return this.props.tasks.map(task => (
        <GlobalSearchItem
          data={task}
          key={`task-${task.id}`}
          onClick={this.props.onClickItem}
        />
      )).concat(this.props.jobs.map(job => (
        <GlobalSearchItem
          data={job}
          isJob
          key={`job-${job.id}`}
          onClick={this.props.onClickItem}
        />
      )));
    }

    return (
      <GlobalSearchItem data={null} />
    );
  }

  _renderLoading() {
    return (
      <div className="vf-global-search__dropdown__loading">
        <Components.EllipsisLoading />
        <div className="vf-global-search__dropdown__loading__text">
          {this.props.strings.searching}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="vf-global-search__dropdown">
        {this.props.isLoading ? this._renderLoading() : this._renderResults()}
      </div>
    );
  }
}

GlobalSearchDropdown.displayName = 'Global Search Dropdown';

GlobalSearchDropdown.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  jobs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
  })),
  onClickItem: PropTypes.func.isRequired,
  strings: PropTypes.shape().isRequired,
  tasks: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
  })),
};

GlobalSearchDropdown.defaultProps = {
  jobs: [],
  tasks: [],
};

export default translate('GlobalSearch')(GlobalSearchDropdown);
